// Shared language options for video / community tagging + filtering.
export const VIDEO_LANGS = {
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  it: "Italiano",
  zh: "Chinese",
  ja: "Japanese",
  pt: "Português",
};
